import { Injectable } from '@angular/core';
import { AppInsightsMonitoringService } from '../app-insights-monitoring.service';
import { ErrorHandler } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsErrorHandlerService extends ErrorHandler {

  constructor(private appInsightsMonitoringService: AppInsightsMonitoringService) {
    super();
  }

  handleError(error: any) {
    this.appInsightsMonitoringService.logException(error);
  }


}
